<template>
  <div class="courseDetail site_contain" :class="[_isMobile()?'mobile':'']" @scroll="handleScroll">
    <div class="cursor"></div>
    <section class="section-main overflow-hidden backgroundStyle" id="main" :style="{'backgroundImage':`url('${bacgrkgroundImages[0]}')`}"> 
      <div class="section-main-sub position-relative">
        <div class="media-main">
          <img src="../assets/imgs/course/media-line-top.svg" alt="media-line-top">
          <div>
            <a-popover placement="right">
              <template slot="content">
                <img src="../assets/imgs/course/watch_image.jpg" class="ewm_box" alt="" />
              </template>
              <p><i class="iconfont icon">&#xe610;</i></p>
            </a-popover>
          </div>
          <div>
            <a-popover placement="right">
              <template slot="content">
                <img src="../assets/imgs/course/watch_image.jpg" class="ewm_box" alt="" />
              </template>
              <p><i class="iconfont icon">&#xe60f;</i></p>
            </a-popover>
          </div>
          <div>
            <a-popover placement="right">
              <template slot="content">
                <img src="../assets/imgs/course/watch_image.jpg" class="ewm_box" alt="" />
              </template>
              <p><i class="iconfont icon">&#xe882;</i></p>
            </a-popover>
          </div>
          <div>
            <a-popover placement="right">
              <template slot="content">
                <img src="../assets/imgs/course/watch_image.jpg" class="ewm_box" alt="" />
              </template>
              <p><i class="iconfont icon">&#xe653;</i></p>
            </a-popover>
          </div>
          <img src="../assets/imgs/course/media-line-bottom.svg" alt="media-line-bottom">
        </div>
        <div class="container2 position-relative overflow-hidden">
          <p class="main-text wow animate__animated animate__slideInDown" data-aos="fade-down">{{ showConfig.welcomeText || '' }} <span>👋</span></p>
          <h1>{{ showConfig.courseNameEn || '' }}</h1>
          <div class="home-girl-img-main" style="margin-top: 20px;">
            <swiper ref="mySwiperKc" :options="chSwiperOptions" style="height: 569px;border-radius: 20px;"
              class="swiper-wrappe carousel">
              <swiper-slide class="swiper-slide" style="width:100%" v-for="(b, i) in showConfig.courseBanner" :key="i">
                <img style="width: 100%;height: 100%;border-radius: 20px;object-fit: cover;" :src="b.filePath" alt="">
              </swiper-slide>
              <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
            </swiper>
          </div>
        </div>
        <div class="section-main-right-contain overflow-hidden wow animate__animated animate__slideInRight">
          <div class="section-main-right-contain-sub" data-aos="fade-left">
            <h2 class="total-project">{{ showConfig.rightNumber || '' }}</h2>
            <p class="project-complted">{{ showConfig.rightText || '' }}</p>
          </div>
          <div class="flower-box" data-aos="fade-left">
            <img class="flower" src="../assets/imgs/course/flower.png" alt="flower">
            <div v-html="showConfig.rightContent"></div>
          </div>
          <div class="mouse-scroll-box" @click="goUnit">
            <div class="mouse" style="cursor: pointer;">
              <i class="iconfont" >&#xe68a;</i>
            </div>
            <h2 class="scroll-down" style="padding-left: 10px">进入 <br /> 课程</h2>
          </div>
        </div>
      </div>
    </section>
    <!-- 课程概况 -->
    <div v-show="showConfig.courseOverviewImagesIds_status == 1" class="Marquee-main overflow-hidden backgroundStyle" :style="{'backgroundImage':`url('${bacgrkgroundImages[1]}')`}">
      <h3 data-aos="fade-down" style="text-align: left;padding: 0 30px;">课程概况 | course</h3>
      <div class="logos logos2">
        <div class="logos-slide">
          <div class="marquee__content">
            <div class="marquee-img-main" v-for="item, index in showConfig.courseOverviewImages" :key="index">
              <img class="brand-logos" :src="item.filePath" alt="brand-logo1">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程介绍 -->
    <section class="section-two overflow-hidden backgroundStyle" :style="{'min-height':'906px','backgroundImage': _isMobile() ? '' : `url('${bacgrkgroundImages[2]}')`}" id="section-two">
      <div class="containerTwo">
        <div class="row section-two-row">
          <div class="col-xxl-6 col-xl-6 col-lg-6 position-relative section-two-col-one" data-aos="fade-up">
            <!-- template -->
            <tag-cloud ref="tagCloud"></tag-cloud>
            <div class="hwlo">
              <img class="years-img" src="../assets/imgs/course/years-img.png" alt="years-img">
              <div class="digit">40+</div>
              <div class="circle-text">核心知识点<br> 机械-编程-物理-数学</div>
            </div>
          </div>
          <div class="col-xxl-6 col-xl-6 col-lg-6" :style="{'marginTop':_isMobile() ? '60px' : ''}">
            <div class="award-circle-main wow animate__animated animate__bounceIn" data-aos="zoom-in">
              <div class="award-circle">
                <img style="width:40px;height:40px" v-if="showConfig.introduceImage" :src="showConfig.introduceImage[0].filePath" alt="trophy">
              </div>
              <div class="" v-html="showConfig.introduceImageText">
                
              </div>
            </div>
            <div v-html="showConfig.introduceCotent" class="wow animate__animated animate__slideInUp"></div>
            <!-- <p class="explore-me" data-aos="fade-right">
              <a href="about.html#explore-me">EXPLORE ME
                <svg class="expo-arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
                  fill="none">
                  <g>
                    <path d="M6.66669 16H25.3334" stroke="#FFDB59" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M20 21.3333L25.3333 16" stroke="#FFDB59" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M20 10.6666L25.3333 16" stroke="#FFDB59" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </g>
                </svg>
              </a>
            </p> -->
          </div>
        </div>
      </div>
    </section>
    <!-- 课程大纲 -->
    <div class="backgroundStyle" v-if="false"  :style="{'padding':'30px 0','backgroundImage':`url('${bacgrkgroundImages[3]}')`}">
      <div class="outlineBox" ref="scrollableElement" :style="{'backgroundImage':`url('${showConfig.outlineBackgroundImage ? showConfig.outlineBackgroundImage[0].filePath : '~@/theme/wayi/assets/imgs/course/ipd.png'} ')`}">
        <div class="outlineContent" ref="scrollableDiv" @scroll="handleScroll">
          <ul class="lineBox">
            <li class="lineList" v-for="item,index in courseUnitDataSource" :key="index">
              {{ item.typeName }}
              <ul class="erLineBox" style="padding-left: 30px">
                <li class="erLineList">
                  {{ item.typeDesc }}
                  <ul class="childrenBox" style="padding-left: 60px">
                    <li class="childrenList" v-for="b,i in item.unitList" :key="b.key">
                      {{i+1}}.{{ b.title }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 要求 -->
    <section class="section-three overflow-hidden backgroundStyle" :style="{'backgroundImage':`url('${bacgrkgroundImages[4]}')`,backgroundSize:auto}">
        <div class="containerTwo">
            <div class="row services-section">
                <div class="col-xxl-4 col-xl-4 col-lg-4 wow animate__animated animate__slideInLeft">
                    <div class="" v-html="showConfig.studyTips"></div>
                    <div class="services-circle-main">
                       <div class="contact-circle" style="left: 0;"> 
                        <div class="view-work-circle btn btn2" :class="[contactNum ==1 ? 'view-work-circle-active':'']" @click="switchContactFn(1,'studyList')">学情<br/>分析</div>
                        </div>
                        <div class="contact-circle" @click="switchContactFn(2,'knowledgeReserveList')" >
                            <div class="view-work-circle btn btn2" :class="[contactNum ==2 ? 'view-work-circle-active':'']">学前能力<br/>要求</div>
                        </div>
                        <div class="contact-circle" style="left: 220px;" @click="switchContactFn(3,'graduateList')" >
                            <div class="view-work-circle btn btn2" :class="[contactNum ==3 ? 'view-work-circle-active':'']">毕业能力<br/>收获</div>
                        </div>
                    </div>
                </div>
                <div class="col-xxl-7 col-xl-7 col-lg-7 wow animate__animated animate__slideInUp">
                    <div id="faq-sec">
                      <a-collapse v-model="activeKey"  expand-icon-position="right">
                        <template #expandIcon="props">
                          <a-icon type="plus" :rotate="props.isActive ? 90 : 0" />
                        </template>
                        <a-collapse-panel v-for="item in courseViewList" :key="String(item.id)" :disabled="!loginStatus">
                          <p slot="header">{{item.name}}</p>
                          <p v-html="item.content"></p>
                        </a-collapse-panel>
                      </a-collapse>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- 哇一轮播 -->
    <div class="header_full_sec overflow-hidden backgroundStyle" :style="{'backgroundImage':`url('${bacgrkgroundImages[5]}')`}">
        <div class="logos">
            <div class="logos-slide">
                <!-- <div class="ticker__item"></div> -->
                <div class="ticker__item ticker__item_dark">助力</div>
                <div class="ticker__item">青少年</div>
                <div class="ticker__item ticker__item_dark">攀登科技顶峰</div>
                <div class="ticker__item">的黄埔军校</div>
                
            </div>
        </div>
    </div>
    <!-- 评论 -->
    <section v-show="showConfig.evaluateList_status == 1" class="section-six overflow-hidden backgroundStyle" :style="{'backgroundImage':`url('${bacgrkgroundImages[6]}')`}">
        <div class="containerTwo wow animate__animated animate__slideInLeft">
            <p class="our-services" data-aos="fade-up">FEEDBACK</p>
            <h2 class="our-solution latest_project" data-aos="fade-down">听听孩子们的声音 -Voice of Students</h2>
            <div class="testimonial_slider wow animate__animated animate__bounceInUp" data-aos="zoom-in-left">
              <swiper ref="mySwiperKc" :options="swiperOptions" style="height: 353px" class="swiper-wrappe carousel">
                    <swiper-slide class="swiper-slide"  v-for="(b,i) in showConfig.evaluateList" :key="i">
                      <div class="evaluate_box">
                        <div class="great-work-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30"
                                fill="none">
                                <g>
                                    <path
                                        d="M11.9903 8.97047L11.9834 8.98364L11.977 8.997C10.9357 11.1534 10.3315 13.3985 10.1705 15.7265L10.1087 16.6197L10.9897 16.7794L16.4359 17.7668V29H1V20.6818C1 15.4562 2.21666 11.3738 4.55213 8.33851C6.85551 5.3666 9.89607 3.01035 13.7015 1.27904L15.1132 3.79798C14.0057 5.37106 12.9651 7.09582 11.9903 8.97047ZM34.5544 8.97047L34.5475 8.98364L34.5411 8.997C33.4998 11.1534 32.8956 13.3985 32.7346 15.7265L32.6728 16.6197L33.5538 16.7794L39 17.7668V29H23.5641V20.6818C23.5641 15.4561 24.7808 11.3737 27.1163 8.33843C29.4197 5.36656 32.4602 3.01033 36.2656 1.27904L37.6773 3.79798C36.5698 5.37106 35.5292 7.09583 34.5544 8.97047Z"
                                        stroke="#FF7D61" stroke-width="2" />
                                </g>
                            </svg>
                            <h3>{{ b.title }}</h3>
                        </div>
                        <p class="posuere">{{b.content}}
                        </p>
                        <svg class="slider-line" xmlns="http://www.w3.org/2000/svg" height="33" viewBox="0 0 630 33"
                            fill="none">
                            <path d="M630 1H100L70 31V1H0" stroke="#909090" />
                        </svg>
                        <div class="client_details">
                            <img class="testimonial_client_img" :src="b.imageUrl[0].filePath"
                                alt="testimonial_client_img1">
                            <div>
                                <h3 class="client-name">{{ b.name }}</h3>
                                <p class="studio">name-old</p>
                            </div>
                        </div>
                      </div>
                    </swiper-slide>
                    <!-- <div v-show="list && list.length > 1" class="swiper-pagination swiper-pagination-white" slot="pagination"></div> -->
                </swiper>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import UnitViewModal from "@/components/course/UnitViewModal";
import courseHeader from "../components/course/header.vue";
import introduce from "../components/course/introduce.vue";
import outline from "../components/course/outline.vue";
import { gsap } from '@/utils/gsap.js'
import tagCloud from '../components/course/brightTag'
import { getQiniuUrl,getQiniuUrlId } from '@/utils/qiniu.js'
import { WOW } from "wowjs";
export default {
  mixins: [mixinDevice],
  components: {
    UnitViewModal,
    courseHeader,
    introduce,
    outline,
    tagCloud,
  },
  data() {
    return {
      bacgrkgroundImages:[],
      id: "",
      departId: "",
      source: "",
      courseUnitDataSource: [],
      info: {},
      token: "",
      tenantConfig: {},
      swiperStatus: true,
      chSwiperOptions: {
        autoplay: true,
        speed: 800,
        slidesPerView:'auto',
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        loop: true,
      },
      imageList: [],
      contactNum:1,
      activeKey:[],
      // 学生评价
      swiperOptions:{
            autoplay:true,
            speed: 800,
            observer: true,
            observeParents: true,
            slidesPerView: 2, // 大于900像素时显示3个幻灯片
            spaceBetween: 20,  // 可选：设置间距
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            loop: true,
            breakpoints: {
                920: {  //当屏幕宽度小于等于1280
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                768: {  //当屏幕宽度小于等于768
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
            } 
        },
        // 课程介绍
        scrollingElement: null,
        canScrollPage: true,
        showConfig:{},
        courseViewList:[],
        scrollingElement: null,
        canScrollPage: true,
      loginStatus:false,
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    this.bacgrkgroundImages = this.tenantConfig.course_background_image.split(',')
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.id = this.$route.query.id;
    this.source = this.$route.query.source;
    this.departId = this.$route.query.departId;
    this.getInfo();
    if (Vue.ls.get(ACCESS_TOKEN)) {
      this.token = Vue.ls.get(ACCESS_TOKEN);
      this.loginStatus = true
    }else{
      this.loginStatus = false
    }
  },
  mounted() {
    // this.scrollingElement = this.$refs.scrollableElement;
    // window.addEventListener('scroll', this.handleScroll);
    // window.addEventListener('wheel', this.handleWheel);    
    this.$nextTick(()=>{
     const wow = new WOW({
     boxClass: 'wow',            
     animateClass: 'animated',   
     offset: 0,                 
     mobile: true,              
     live: true,                
     callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
       },
       scrollContainer: null,     
     })
     wow.init()
   })
  },
  methods: {
    // 其他方法...
    handleScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = this.scrollingElement.offsetTop ;
      // console.log(elementTop , 'elementTop')
      const elementBottom = elementTop + this.scrollingElement.clientHeight;

      if (scrollTop >= elementTop && scrollTop < elementBottom) {
        // console.log('阻止页面滚动')
          event.preventDefault(); // 阻止页面滚动
          this.canScrollPage = false;
      } else {
        // console.log('允许页面滚动')
        this.canScrollPage = true;
      }
    },
    handleWheel(event) {
      if (!this.canScrollPage) {
        event.preventDefault(); // 阻止页面滚动
      }
    },
    // 进入课程
    goUnit(){
      const routeData = this.$router.resolve({
        path:'/courseUnitModel',
        query:{ courseId: this.id}
      });
      window.open(routeData.href, '_blank');
    },
    // 课程介绍
    clickTagItem(tag){
    },
    getInfo() {
      getAction("/teaching/teachingCourse/get", { id: this.id }).then((res) => {
        if (res.success) {
          this.info = res.result;
          this.showConfig = JSON.parse(res.result.showConfig) 
          let tabList = this.showConfig.tabList.split('\n')
          let list = tabList.map((val,index)=>{
            return {
              id:index+1,
              name:val
            }
          })
          if(this.$refs.tagCloud){
            this.$refs.tagCloud.list = list
          }
          this.courseViewList = this.showConfig.studyList
          this.getList()
          this.$nextTick(()=>{
            this.initSystem()
          })
        }
      });
    },
    getList() {
        getAction("/teaching/teachingCourseUnit/showCourseUnitTreeWithType", {
          courseId: this.id,
        }).then((res) => {
          if (res) {
            this.courseUnitDataSource = res;
          }
        });
    },
    toCourse(unit) {
      // if(!unit.departId){
      //   this.$message.info('本课程仅做展示，请从个人中心进入课程')
      //   return
      // }
      if (
        unit.isUnitOpen == 0 ||
        (unit.isUnitOpen == 2 && unit.openTime > unit.serverTime)
      ) {
        this.$message.info("未开课");
        return;
      }
      this.$refs.unitViewModal.view(unit);
    },
    switchContactFn(val,data){
      this.contactNum = val
      this.courseViewList = this.showConfig[data]
      this.activeKey = []
    },
    // 初始化内容
    initSystem() {
      // 头部信息鼠标样式
      let cursor = document.querySelector('.cursor');
      let cursorScale = document.querySelectorAll('.mouse-scroll-box,p,button,.nested-accordion,.trigger,.html-popup,.youtube,#vimeo,.link,.new-img-box-main,.cursor-pointer,.cursor-arrow,.play-button,.cf_image');
      let mouseX = 0;
      let mouseY = 0;
      gsap.to({}, 0.016, {
        repeat: -1,
        onRepeat: function () {
          gsap.set(cursor, {
            css: {
              left: mouseX,
              top: mouseY,
            }
          })
        }
      });
      window.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
      })
      cursorScale.forEach(link => {
        link.addEventListener('mousemove', () => {
          cursor.classList.add('grow');
          if (link.classList.contains('small')) {
            cursor.classList.remove('grow');
            cursor.classList.add('grow-small');
          }
        });

        link.addEventListener('mouseleave', () => {
          cursor.classList.remove('grow');
          cursor.classList.remove('grow-small');
        });
      });
      //课程概况轮播
      document.querySelectorAll('.logos').forEach(function (logosContainer) {
        const copy = logosContainer.querySelector('.logos-slide').cloneNode(true);
        logosContainer.appendChild(copy);
      });
     
    }
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll);
    // window.removeEventListener('wheel', this.handleWheel);
  }
};
</script>
<style scoped>
@import '../assets/css/bootstrap.min.css';
@import '../assets/css/style.css';

</style>
<style lang="less" scoped>
@media only screen and (min-width: 1200px) {
  .section-main-sub{
    display: flex;
    justify-content: center;
  }
  .media-main{
    // display: none;
    padding-left: 150px;
  }
  .section-main-right-contain{
    max-width: 314px;
  }
  .section-two{
    // background-image: url('');
  }
}
@media only screen and (min-width: 781px) and (max-width: 1200px) {
  .section-main-sub{
    // display: inline-block;
  }
  .main-text{
    font-size: 24px;
  }
  .container2 h1{
    font-size: 42px;
  }
  .media-main{
    // display: none;
    padding-left: 20px;
  }
  .section-main-right-contain{
    max-width: 250px;
  }
  .section-two-col-one{
    margin-bottom: 80px;
  }
}
@media only screen and (max-width: 780px) {
  .section-two{
    background-image: none !important;
  }
  .section-main-sub{
    display: inline-block;
  }
  .main-text{
    font-size: 32px;
  }
  .container2 h1{
    font-size: 36px;
  }
  .media-main{
    display: none;
  }
  .section-main-right-contain{
    max-width: 100%;
  }
   .section-two-col-one{
    margin-bottom: 80px;
  }
  .section-main-right-contain-sub{
    display: none;
  }
}
/deep/.ant-collapse{
  background: transparent !important;
  border: none !important;
  color: #fff !important;
}
/deep/.ant-collapse > .ant-collapse-item{
  border-color: #eeeeee6b !important;
}
/deep/.ant-collapse > .ant-collapse-item > .ant-collapse-header{
  color: #fff !important;
  font-size: 24px !important;
  padding-bottom: 20px !important;

}
/deep/.ant-collapse-content{
  background: transparent !important;
  color: #fff !important;
  border: none !important;
}
/deep/.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow{
  font-size: 24px !important;
}
.ewm_box {
  width: 150px;
  height: 150px;
}

@media only screen and (min-width: 991px) {}

@media only screen and (max-width: 991px) {}


.outlineBox {
  width: 100%;
  max-width: 1200px;
  height: 700px;
  margin: 0 auto;
  // background-image: url('~@/theme/wayi/assets/imgs/course/ipd.png');
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .outlineContent {
    padding: 5px 40px;
    border-radius: 30px;
    width: 95%;
    height: 600px;
    overflow-y: auto;
    // background: #fff;
    margin: 30px auto;
    color: #fff;
  }

  .outlineContent::-webkit-scrollbar {
    display: none
  }
  .lineBox , .erLineBox , .childrenBox{
    width: 100%;
    color: #ffff;
  }
  .lineBox{
    padding-left: 0 !important;
    line-height: 55px;
  }
  .erLineBox{
    padding-left: 15px !important;
    line-height: 45px;
  }
  .childrenBox{
    padding-left: 30px !important;
    line-height: 35px;
  }
  .lineList{
    font-size: 32px;
  }
  .erLineList{
    font-size: 26px;
  }
  .childrenList{
    font-size: 18px;
  }
}
</style>